export const blockIconsEditorNotes = (
	<span className='material-symbols-outlined'>notes</span>
);
